import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function checkName(code) {
    if (code) {
        let rs = ""
        let Url = genURL("CSSITE/Getsite?Code=" + code + "&user=" + localStorage.getItem("Username"))
        console.log(Url);
        await axios.get(Url).then((res) => {
            if (res.data.length === 1) {
                rs = res.data[0].MYNAMETH
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};